import { Component, OnInit } from '@angular/core';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';

import { ContractApprovalService } from 'src/app/services/contract-approval.service';
import { MovementService } from 'src/app/services/movement.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { SharedService } from 'src/app/services/shared.service';
import { TokenService } from 'src/app/services/token.service';
import { Location } from '@angular/common';

import { ApproveContractWithTokenDto } from 'src/app/models/ApproveContractWithTokenDto';

import { ContractDto } from 'src/app/models/contractDto';


import { NotificationType } from 'src/app/models/notification.message';
import { ApproveMovementWithTokenDto } from 'src/app/models/ApproveMovementWithTokenDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { MovementDto } from 'src/app/models/MovementDto';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { ActivatedRoute, Router } from '@angular/router';
import { ApproveManPowerWithTokenDto } from 'src/app/models/ApproveManPowerWithTokenDto';


@Component({
  selector: 'app-approvemanp',
  templateUrl: './approvemanp.component.html',
  styleUrls: ['./approvemanp.component.css']
})
export class ApprovemanpComponent implements OnInit {
  token: string="";
  hasUserApprovedContract:boolean=false;
  contract!:ManPowerDto;
  UpdateRequest:any;
  RequestApprovals: RequestApprovalDto[] | undefined;
  pdf:string="";
  thecontent:string="";
  PathReportString:string="";
  visible = false;
  showthedoc:boolean=false;
  Comment:string='';
  experience:string='';
  skillsrequired:string='';
  educationalqualification:string='';
  justification:string='';

  constructor( private sanitizer: DomSanitizer,  private location:Location ,  private route: ActivatedRoute,  private tokenService: TokenService, private router: Router,
    private notification: NotificationService, private sharedService: SharedService,    private contractApprovalService :ContractApprovalService,
    private requestApprovalService: RequestApprovalsService,  private MovementService: MovementService,  private _ActivatedRoute: ActivatedRoute  ) 
    { 
     
  }
  ngOnInit(): void {
    this.route.queryParams
    .subscribe(params => {
      console.log(params);  
      this.token = params.to;
      console.log(this.token);  
    }
  );

  if(this.token.length==0)
  {
    this.router.navigate(['/approverequests']);

  }
;
  this.LoadData();
   this.location.replaceState(this.location.path().split('?')[0], '');
  


  var snapshot = this._ActivatedRoute.snapshot;
  const params = { ...snapshot.queryParams };
  delete params.pos
  this.router.navigate([], { queryParams: params });
}





async LoadData()
{
  
  ;
  let resLo = await this.contractApprovalService.BeginManpowerApproval(this.token).toPromise();
  var payload  = <ApproveManPowerWithTokenDto>resLo.responseData;
  let model = payload.manpowerRequest;
  this.contract=model;
 
  this.skillsrequired=model.skillsRequired;
  this.educationalqualification=model.qualification;
  this.experience = model.experience;
  this.justification = model.justification;
  

if(payload.hasUserApprovedContract)
{
this.hasUserApprovedContract = true;
}
this.UpdateRequest = payload.manpowerRequest;
window.localStorage.clear();
// store token

this.sharedService.loginResponseData = payload.login;
this.tokenService.saveSession(payload.login);
this.tokenService.setInfo(payload.login);


console.log(this.contract);

let resApprovals = await this.requestApprovalService.getByManpowerRequestId(this.contract.id).toPromise();
  this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;

  this. thecontent = model.JobDescription.documentContent;
  if(this.thecontent.length>0)
  {
  
  this.showthedoc =true;
  this.thecontent=this.thecontent.substring(28);
  this.pdf = model.JobDescription.documentContent;
   
  }
  

}
cancel()
{
 this.router.navigateByUrl('/dashboard');
// this.router.navigate(['/dashboard']);
}


showDocument():void{
  // this.open();
 
 
 
   
 
  const pdfWindow = window.open("")!;    
 pdfWindow.document.write("<html<head><title>Additional Document</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
 pdfWindow.document.write("<body><embed  width='600' height='780' style='position: absolute;top: 66px;bottom: 0px;right: 0px;width: 100%;border: none;margin: 0;padding: 0;overflow: hidden;z-index: 3;height: 100%;'  src='data:application/pdf;base64, " +    
     encodeURI(this.thecontent) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
 
 
 }
 
 
async approveContract() {

  
  const model: approveContractVm = { id: this.contract.id, message: this.Comment, token:this.token };
;
  this.contractApprovalService.ApproveManpowerWithToken(model).subscribe({
    next: (data => {
       ;
      if (data.responseCode == "00") {
        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.success
        });
     ;
        this.router.navigate(['/dashboard']);
     
      }
      else {

        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.error
        });

      }

    }),
    error: ((error: any) => {
      console.log(error.error);
     


      this.notification.sendMessage({
        message: error.error.message,
        type: NotificationType.error
      });

      this.router.navigate(['/dashboard']);
    })

  });

}
cancelReturn()
{
  
 // this.router.navigate(['/dashboard']);
}
async rejectContract() {

if (this.Comment === '') {
  this.notification.sendMessage({
    message: 'Comment is required when rejecting request',
    type: NotificationType.error
  });

  
}
else {
  

 

    const model: approveContractVm = { id: this.contract.id, message: this.Comment, token:this.token };
;
    this.contractApprovalService   .RejectManpowerWithToken(model).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.router.navigate(['/dashboard']);
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.router.navigate(['/dashboard']);
        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.router.navigate(['/dashboard']);
      })

    });

}
}




}
